export enum DashboardSellBuyTabs {
    Sell = 1,
    Buy = 2
}
